
  export default {
    components: {
      LoginAndRegistrationDialog: () =>
        import('@/components/organization/LoginAndRegistrationDialog'),
    },
    data() {
      return {
        jobpostings: [
          {
            color: '#E4BF7B',
            name: 'Standard-Job',
            visual_highlighting: false,
            simple_multiposting: true,
            platforms: '50',
            flexible_durations: true,
            num_locations: '15',
            price: 'ab 45 €',
            number_of_coins: 'oder 2.250 pbCoins',
            special_price: '0 € für Neukunden',
          },
          {
            color: '#DCA441',
            name: 'Power-Job',
            visual_highlighting: true,
            simple_multiposting: true,
            platforms: '75',
            flexible_durations: true,
            num_locations: '25',
            price: 'ab 60 €',
            number_of_coins: 'oder 3.000 pbCoins',
            special_price: '0 € für Neukunden',
          },
          {
            color: '#6E8DB5',
            name: 'Top-Job',
            visual_highlighting: true,
            simple_multiposting: true,
            platforms: '100',
            flexible_durations: true,
            num_locations: '100 / bundesweit',
            price: 'ab 120 €',
            number_of_coins: 'oder 6.000 pbCoins',
            special_price: '0 € für Neukunden',
          },
          {
            color: '#3D6190',
            name: 'Flexi-Job',
            visual_highlighting: true,
            simple_multiposting: true,
            platforms: '100',
            flexible_durations: true,
            num_locations: '100 / bundesweit',
            price: '5 €',
            special_price: 'Abrechnung pro Bewerbung',
          },
        ],
      };
    },
  };
